import { Component, Prop, Vue } from 'vue-property-decorator'

import { DashmixBox } from '../../../dsl/backoffice'

import { ContactDataContent } from '../Contact.contracts'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
@Component<ContactDataTabUI>({
  name: 'ContactDataTabUI',
  components: {
    // todo: remove dashmix from front module!
    DashmixBox
  },

  template: `
    <section>
      <div class="container">
        <div class="row">
          <div class="contact__data">
            <div v-for="item in items" :key="item.title" class="contact__data__card">
              <h5>{{ item.title }}</h5>
              <div v-html="item.description"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  `
})
export class ContactDataTabUI extends Vue {
  @Prop({ type: Array, required: true, default: () => [] })
  public items!: ContactDataContent[]
}
